export interface PaymentMethodOption {
  id: string | number;
  label: string;
  name?: string;
  inactive?: boolean;
}

type Translate = (key: string) => string;

const PAYMENT_METHOD_LABEL_KEYS: Record<string, string> = {
  CREDIT: "fueling.paymentMethod.credit",
  CREDITO: "fueling.paymentMethod.credit",
  DEBIT: "fueling.paymentMethod.debit",
  DEBITO: "fueling.paymentMethod.debit",
  CASH: "fueling.paymentMethod.cash",
  DINHEIRO: "fueling.paymentMethod.cash",
  PIX: "fueling.paymentMethod.pix",
};

const LEGACY_NAME_BY_CODE: Record<string, string> = {
  CREDIT: "CREDITO",
  CREDIT_CARD: "CREDITO",
  DEBIT: "DEBITO",
  DEBIT_CARD: "DEBITO",
  CASH: "DINHEIRO",
};

const VEHICLE_TAG_NAME = "TAG DO VEICULO";

const normalize = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();

export const isVehicleTagPaymentMethod = (option?: { name?: string; label?: unknown } | null): boolean =>
  [option?.name, option?.label].some(
    (value) => typeof value === "string" && normalize(value.trim()) === VEHICLE_TAG_NAME
  );

export const resolvePaymentMethodLabel = (
  value: string | number | null | undefined,
  t: Translate,
  options: PaymentMethodOption[] = []
): string | null => {
  if (value == null) return null;

  const raw = String(value).trim();
  if (!raw) return null;

  const labelKey = PAYMENT_METHOD_LABEL_KEYS[normalize(raw)];
  if (labelKey) return t(labelKey);

  const option = options.find((item) => String(item.id) === raw);
  return option?.label ?? raw;
};

export const resolvePaymentMethodId = (
  value: string | number | null | undefined,
  options: PaymentMethodOption[] = []
): string => {
  if (value == null) return "";

  const raw = String(value).trim();
  if (!raw) return "";

  if (options.some((item) => String(item.id) === raw)) return raw;

  const normalized = normalize(raw);
  const target = LEGACY_NAME_BY_CODE[normalized] ?? normalized;
  const option = options.find((item) =>
    [item.name, item.label].some((name) => !!name && normalize(name.trim()) === target)
  );

  return option ? String(option.id) : raw;
};
